export const filterProductsInDistribution = (distributionsArray) => {
  let result;
  const productsInDistribution = distributionsArray.filter((value) => {
    if (value.product && value.product?.movile) {
      result = value.product.movile;
    } else if (value.product && value.product?.accesory) {
      result = value.product.accesory;
    } else if (value.product && value.product?.chip) {
      result = value.product.chip;
    } else if (value.product && value.product?.cash_card) {
      result = value.product.cash_card;
    }
    return result;
  });
  return productsInDistribution;
};

const filterDistributionsByImei = (imei, distributionsArray) => {
  return distributionsArray.filter(
    (item) => item.product?.movile?.imeiCode === imei
  );
};

const filterDistributionsByAccesoryBarCode = (barCode, distributionsArray) => {
  return distributionsArray.filter(
    (item) => item.product?.accesory?.barCode === barCode
  );
};

const filterDistributionsByChipBarCode = (iccid, distributionsArray) => {
  return distributionsArray.filter(
    (item) => item.product?.chip?.iccid === iccid
  );
};

export const filterDistributions = (
  inputValue,
  productTypeId,
  distributionsArray
) => {
  if (productTypeId === 1) {
    const movilesFiltered = filterDistributionsByImei(
      inputValue,
      distributionsArray
    );
    return movilesFiltered;
  } else if (productTypeId === 2) {
    const accesoriesFiltered = filterDistributionsByAccesoryBarCode(
      inputValue,
      distributionsArray
    );
    return accesoriesFiltered;
  } else if (productTypeId === 3) {
    const chipsFiltered = filterDistributionsByChipBarCode(
      inputValue,
      distributionsArray
    );
    return chipsFiltered;
  }
};
